import Reveal from "@/components/base/Reveal";
import { includedFeatures } from "@/mocks/hospedagem";

export default function IncludedFeatures() {
  return (
    <section className="bg-background-50 py-16 md:py-24">
      <div className="mx-auto max-w-7xl px-4 md:px-8">
        <div className="grid grid-cols-1 gap-12 lg:grid-cols-[0.85fr_1.15fr] lg:gap-16">
          <Reveal>
            <div className="lg:sticky lg:top-28">
              <span className="inline-flex items-center gap-2 rounded-full bg-accent-50 px-4 py-1.5 text-xs font-semibold uppercase tracking-wide text-accent-700">
                <i className="ri-checkbox-multiple-line" aria-hidden="true"></i>
                O que está incluído
              </span>
              <h2 className="mt-5 font-heading text-2xl font-bold tracking-tight text-foreground-950 md:text-4xl">
                Tudo o que a sua hospedagem precisa trazer.
              </h2>
              <p className="mt-4 text-base leading-relaxed text-foreground-600">
                Independente do plano escolhido, a sua estrutura contará com os recursos essenciais
                para manter o seu negócio online com segurança e bom desempenho.
              </p>
              <div className="mt-8 rounded-xl border border-background-200 bg-background-100/70 p-5">
                <div className="flex items-center gap-3">
                  <span className="flex h-11 w-11 items-center justify-center rounded-lg bg-primary-500 text-background-50">
                    <i className="ri-exchange-2-line text-xl" aria-hidden="true"></i>
                  </span>
                  <div>
                    <p className="font-heading text-sm font-semibold text-foreground-950">
                      Migração com acompanhamento
                    </p>
                    <p className="text-xs text-foreground-600">
                      Cuidamos da transição do seu projeto para a NXHOST.
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </Reveal>

          <div className="grid grid-cols-1 gap-5 sm:grid-cols-2">
            {includedFeatures.map((feature, index) => (
              <Reveal key={feature.title} delay={index * 60} className="h-full">
                <article className="flex h-full flex-col rounded-xl border border-background-200 bg-background-50 p-6 transition-colors hover:border-accent-300 hover:bg-background-100/60">
                  <span className="flex h-11 w-11 items-center justify-center rounded-lg bg-accent-100/70 text-accent-700">
                    <i className={`${feature.icon} text-xl`} aria-hidden="true"></i>
                  </span>
                  <h3 className="mt-4 font-heading text-base font-semibold text-foreground-950">
                    {feature.title}
                  </h3>
                  <p className="mt-2 text-sm leading-relaxed text-foreground-600">
                    {feature.description}
                  </p>
                </article>
              </Reveal>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}